<template>
  <v-card>
    <v-form @submit.prevent="submitEditComplianceResource()" ref="editComplianceResourceForm">
      <v-container grid-list-lg>
        <v-layout wrap>
          <dialog-header :title="title" :details="`ID: ${editedComplianceResource.id} (${editedComplianceResource.name})`"></dialog-header>
          <!-- <v-flex xs12 sm6>
            <v-select :items="models"
              v-model="editedComplianceResource.model"
              label="* Model" 
              :prepend-icon="$store.state.global.pages.client.icon"
              :color="$store.state.global.pages.client.color"
              :rules="modelRules"
            ></v-select>
          </v-flex>-->
          <!-- <v-flex xs12 sm6>
            <v-select :items="resourceTypes"
              v-model="editedComplianceResource.resourceType"
              label="* Resource Type"
              prepend-icon="build"
              :color="primaryNeutral"
              :rules="resourceTypeRules"
              :disabled="!model"
            ></v-select>
          </v-flex>-->
          <!-- <v-flex xs12>
            <v-autocomplete :items="subjects"
              v-model="editedComplianceResource.subjectId"
              :label="`* Select ${selectedModel.text}`"
              :prepend-icon="$store.state.global.pages[selectedModel.value].icon"
              :color="primaryNeutral"
              :rules="subjectIdRules"
              item-value="id"
              :item-text="selectedModel.nameField || 'name'"
              :disabled="!model"
            ></v-autocomplete>
          </v-flex>-->
          <v-flex xs12>{{editedComplianceResource.typeDisp}}</v-flex>
          <input type="file" ref="fileUpload" style="display:none" @change="onFileChange" />
          <v-flex xs12 sm6>
            <v-text-field
              :label="`* Select ${editedComplianceResource.typeDisp} file`"
              :color="primaryNeutral"
              readonly
              :value="!!file ? file.name : ''"
              @click="openFileDialog"
              :loading="loading"
              prepend-icon="attach_file"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <date-picker-wrapper
              :label="`* Expiry Date`"
              :color="primaryNeutral"
              v-model="editedComplianceResource.expiryDate"
              prepend-icon="calendar_today"
              :rules="expiryDateRules"
            ></date-picker-wrapper>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              label="Notes"
              v-model="editedComplianceResource.notes"
              :color="primaryNeutral"
              prepend-icon="note"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat color="grey darken-1" @click="close()">Close</v-btn>
        <v-btn flat color="green" :disabled="!file" :loading="loading" type="submit">
          <v-icon left>cloud_upload</v-icon>Update
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import ComplianceService from "@/services/requests/complianceService";
import Store from "@/store/computed/storeHelpers";

// MIXINS
import EditComplianceResourceValidation from "./validation/editComplianceResourceValidation";
import models from "./mixins/models";

// COMPONENTS
import DialogHeader from "@/components/ui/dialogHeader";
import DatePickerWrapper from "@/components/ui/datePickerWrapper";

export default {
  mixins: [EditComplianceResourceValidation, models],
  components: {
    DialogHeader,
    DatePickerWrapper
    // UploadCompliance
  },
  data() {
    return {
      uploadDialog: false,
      file: {},
      loading: false,
      editedComplianceResource: Object.assign({}, this.complianceResource)
      // currentData: {},
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    pickerInput(val) {
      this.$emit("input", val);
      this.dateMenu = false;
    },
    fieldInput(val) {
      this.$emit("input", val);
      this.dateMenu = false;
    },
    openUploadDialog(data) {
      this.currentData = data;
      this.uploadDialog = true;
    },
    openFileDialog() {
      this.$refs.fileUpload.click();
    },
    onFileChange() {
      this.file = this.$refs.fileUpload.files[0];
      let data = {
        file: this.file,
        type: this.type,
        model: this.model,
        complianceResourceId: this.complianceResourceId
      };
      this.$emit("fileSelected", data);
    },
    fileSelected(file) {
      this.$emit("fileSelected", file);
    },
    discard() {
      this.editedComplianceResource = Object.assign(
        {},
        this.complianceResource
      );
      this.close();
    },
    submitEditComplianceResource() {
      if (!this.$refs.editComplianceResourceForm.validate()) {
        return;
      }
      let formData = new FormData();
      formData.append("file", this.file);
      formData.append("id", this.editedComplianceResource.id);
      formData.append("expiryDate", this.editedComplianceResource.expiryDate);
      formData.append("key", this.editedComplianceResource.key);
      formData.append("model", this.editedComplianceResource.model);
      formData.append("type", this.editedComplianceResource.type);
      formData.append("subjectId", this.editedComplianceResource.subjectId);
      formData.append("notes", this.editedComplianceResource.notes);
      this.save(formData);
    },
    save(formData) {
      this.loading = true;
      ComplianceService.updateComplianceResource(
        formData,
        this.editedComplianceResource.id
      )
        .then(result => {
          this.handleSuccess(result);
        })
        .catch(err => {
          this.handleError(err);
        });
    },
    handleSuccess(result) {
      console.log(result);
      var compliance = result.data.result;
      compliance.name = !!compliance[compliance.model]
        ? compliance[compliance.model].name
        : "-";
      this.$store.commit("compliance/updateArrayStateById", {
        prop: "compliances",
        value: this.complianceResource,
        editedValue: compliance
      });
      this.editedComplianceResource = Object.assign(
        {},
        result.data.result.complianceResource
      );
      this.snack({ text: result.data.message, color: "green" });
      //this.snack({color: 'green', text: 'Compliance Record was edited'});
      //this.resetForm()
      this.close();
      this.loading = false;
    },
    handleError(err) {
      console.log(err);
      this.snackError();
      //this.snack({text: err.response.data.message, color: 'red'})
      this.loading = false;
    }
  },
  props: {
    title: String,
    complianceResource: Object
  },
};
</script>

<style>
</style>